module.exports = __webpack_public_path__ + "static/juggling_school_kaito_bg-972a2001eb18dbfa126a2e34a1b63e8b.jpg";